import { Admin } from '.';
import { action } from '@play-co/replicant';
import { defineActions } from '../utils';

export default (
  Admin: Pick<Admin, 'schema' | 'getters'>,
  { Inventory }: Admin['$DEPENDENCIES'],
) =>
  defineActions<Admin>()({
    /**
     * Consume gems and give points by provided exchange rate
     */
    claimAdminMessageResources: action((state) => {
      // Get resources counts
      const resources = Admin.getters(state).getReimbursements();

      if (!resources.coins && !resources.gems) {
        throw new Error('No admin message resources to claim.');
      }

      // Add b-points
      if (resources.coins)
        Inventory.modifiers(state).addPoints(resources.coins);

      // Add gems
      if (resources.gems)
        Inventory.modifiers(state).addFreeGems(resources.gems);

      // Remove old messages
      state.admin = state.admin.filter((item) => !item.claimed);

      // Mark all messages as claimed
      for (const message of state.admin) {
        // All other messages, claim instantly.
        message.claimed = true;
      }
    }),
  });
